import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import logo from "../../Images/lifecare logo.png";
import useAuth from "../../hooks/useAuth"
 

const Navbar = () => {
  const {logOut,user,admin}=useAuth();
  
  
 

  return (
    <nav className="px-2  bg-white border-gray-200 shadow-lg  ">
      <div className="container flex flex-wrap justify-between items-center mx-auto">
        <NavLink to="/">
          <img className="w-32" src={logo} alt="" />
        </NavLink>

        <button
          data-collapse-toggle="mobile-menu"
          type="button"
          className="inline-flex justify-center items-center ml-3 text-gray-400 rounded-lg md:hidden hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-300 dark:text-gray-400 dark:hover:text-white dark:focus:ring-gray-500"
          aria-controls="mobile-menu-2"
          aria-expanded="false"
        >
          <span className="sr-only">Open main menu</span>
          <svg
            className="w-6 h-6"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            {/* akhane fill-rule silo ami sekhane fillRule kore disi */}
            {/* akahane clip-rule silo ami sekhane clipRule kore disi */}
            <path
              fillRule="evenodd"
              d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
              clipRule="evenodd"
            ></path>
          </svg>
          <svg
            className="hidden w-6 h-6"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clipRule="evenodd"
            ></path>
          </svg>
        </button>
        <div className="hidden w-full md:block md:w-auto" id="mobile-menu">
          <ul className="flex flex-col mt-4 md:flex-row md:space-x-8 md:mt-0 md:text-sm md:font-medium  md:justify-center md:items-center lg:justify-center lg:items-center">
            <li>
              <NavLink
                to="/home"
                className="block py-2 pr-4 pl-3  rounded md:bg-transparent hover:text-blue-700 md:p-0 md:dark:text-white dark:bg-blue-600 md:dark:bg-transparent"
                aria-current="page"
              >
                Home
              </NavLink>
            </li>
            {!admin&&<li>
              <NavLink
                to="/shop"
                className="block py-2 pr-4 pl-3  rounded md:bg-transparent hover:text-blue-700 md:p-0 md:dark:text-white dark:bg-blue-600 md:dark:bg-transparent"
                aria-current="page"
              >
                Shop
              </NavLink>
            </li>}
           
             <li>
              <button
                id="dropdownNavbarLink"
                data-dropdown-toggle="dropdownNavbar"
                className="flex justify-between items-center py-2 pr-4 pl-3 w-full font-medium text-gray-700 border-b border-gray-100 hover:bg-gray-50 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 md:w-auto dark:text-gray-400 dark:hover:text-white dark:focus:text-white dark:border-gray-700 dark:hover:bg-gray-700 md:dark:hover:bg-transparent"
              >
                Services{" "}
                <svg
                  className="ml-1 w-4 h-4"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  ></path>
                </svg>
              </button>

              <div
                id="dropdownNavbar"
                className="hidden z-10 w-44 text-base list-none bg-white rounded divide-y divide-gray-100 shadow dark:bg-gray-700 dark:divide-gray-600"
              >
                <ul className="py-1" aria-labelledby="dropdownLargeButton">
                  <li>
                    <NavLink
                      to="/dashboard"
                      className="block py-2 px-4 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-400 dark:hover:text-white"
                    >
                      Dashboard
                    </NavLink>
                  </li>
                  {!admin&&<li>
                    <NavLink
                      to="/about"
                      className="block py-2 px-4 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-400 dark:hover:text-white"
                    >
                      About
                    </NavLink>
                  </li>}
                 {!admin&& <li>
                    <NavLink
                      to="/doctors"
                      className="block py-2 px-4 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-400 dark:hover:text-white"
                    >
                      Doctors
                    </NavLink>
                  </li>}
                 
                 {!admin&& <li>
                    <NavLink
                      to="/makAppointment"
                      className="block py-2 px-4 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-400 dark:hover:text-white"
                    >
                      Make Appointment
                    </NavLink>
                  </li>}
                </ul>
               {!admin&& <div className="py-1">
                  <NavLink
                    to="/"
                    className="block py-2 px-4 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-400 dark:hover:text-white"
                  >
                    Contact
                  </NavLink>
                </div>}
              </div>
            </li>

            <li>
              <NavLink to="/">
             {!user?.email && <img
                  className="w-8 rounded-full ml-2 md:m-0 lg:m-0 "
               src="https://i.ibb.co/6JBN8sZ/images.png"
                  alt=""
                />}
               {user.photoURL===null && user.email? 
               <img
                  className="w-8 rounded-full ml-2 md:m-0 lg:m-0 "
               src="https://i.ibb.co/6JBN8sZ/images.png"
                  alt=""
                />:
               <img
                  className="w-8 rounded-full ml-2 md:m-0 lg:m-0 "
               src={user.photoURL}
                  alt=""
                />
              }
              </NavLink>
            </li>
           {user.email? <li>
              <NavLink
              onClick={logOut}
                to="/"
                className="block py-2 px-2 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-400 dark:hover:text-white"
              >
                Logout
              </NavLink>
            </li>
            :
            <li>
              <NavLink
                to="/login"
                className="block py-2 px-2 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-400 dark:hover:text-white"
              >
                Login
              </NavLink>
            </li>}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
// AIzaSyBE1XvRgTye_0gjyb0yAqV7jdxvjimd07Q